<template>
  <div class="uvindex-daily-page">
    <div v-if="isStationsLoaded">
      <form action="?">
          <label class="w75 fl tr" for="dateSelect">Stanica:</label>

          <select class="w200 fl mr-2" id="dateSelect" v-model="selectedStationId">
            <option v-for="option in UVIndexStations" v-bind:value="option.value">
              {{ option.text }}
            </option>
          </select>
          <date-picker
              v-model="dt"
              format="DD.MM.YYYY"
              valueType="timestamp"
              :editable=false
              :clearable=false
              :disabled-date="disabledDates"
          >
          </date-picker>
          <button type="button" class="button w50 ml-2 button-icon-only" :title="$t('prev')" @click="prevDay()" :disabled="prevDisabled"><i class="icon-navigate_before"></i></button>
          <button type="button" class="button w50 ml-2 button-icon-only" :title="$t('next')" @click="nextDay()" :disabled="nextDisabled"><i class="icon-navigate_next"></i></button>
          <span v-if="isLoading" class="pl-2">Načítavam...</span>
        <div class="clearfix"></div>
      </form>
    </div>
    <div class="clearboth5"></div>
    <div class="error" v-if="isError">{{ errorMsg }}</div>
    <div class="clearboth5"></div>
    <template v-if="dailyData.length && !isError">
      <highcharts ref="uvDailyHighcharts" :updateArgs="[true, true, true]" :options="chartOptions"></highcharts>
    </template>
    <template v-if="selectedStationId">
      <UVIndexYearly :station_id="selectedStationId"></UVIndexYearly>
    </template>


  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import '../datepicker-lang-sk';
import SHMUconf from '../shmu_conf';
import Axios from "axios";
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';

import UVIndexDailyChart from '../components/UVIndexDaily-chart-options'
import UVIndexYearly from '../components/UVIndexYearly'



Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
  },
  global: {
    useUTC: false,
  }
});



export default {
  components: {
    DatePicker,
    highcharts: Chart,
    UVIndexYearly,
  },
  name: 'UVIndexDaily',
  props: {
    msg: String
  },
  data() {
    return {
      dt: null,
      minDt: 1577833200 * 1000, // 2020-01-01
      prevDisabled: false,
      nextDisabled: false,
      dailyDataLoaded: false,
      dailyData: [],
      isError: false,
      errorMsg: null,
      stations: [],
      UVIndexStations: [],
      isStationsLoaded: false,
      selectedStationId: null,
      defaultStationId: 11813,
      isLoading: false,
      chartOptions: UVIndexDailyChart,
      stationDataForChart: {}

    }
  },
  watch: {
    dt() {
      let cur_base = this.$moment.unix(this.dt / 1000).format('YYYY-MM-DD 00:00');
      let cur_ts = this.$moment(cur_base).unix() * 1000;

      if (cur_ts <= this.minDt) {
        this.prevDisabled = true;
      } else {
        this.prevDisabled = false;
      }

      if (cur_ts >= this.maxDt) {
        this.nextDisabled = true;
      } else {
        this.nextDisabled = false;
      }

      if (this.selectedStationId && this.isStationsLoaded) {
        this.getDailyData();
      }
    },
    stations() {
      if (this.stations.length > 0) {
        this.stations.forEach(v => {
          this.UVIndexStations.push({
            value: v.id_station,
            text: v.station_name
          });
        });
      }
    },
    selectedStationId() {
      if (this.selectedStationId && this.isStationsLoaded) {
        this.getDailyData();
        this.$ls.set('uvindex_selected_station_id', this.selectedStationId, 365 * 24 * 60 * 60 * 1000); // 1 rok
      }
    },
    isStationsLoaded() {
      this.getDailyData();
    }
  },
  mounted() {
    this.dt = this.today_ts * 1000;
    this.getStations();
  },
  computed: {
    today_ts: function() {
      let base_today = this.$moment().format('YYYY-MM-DD 00:00');
      return this.$moment(base_today).unix();
    },
    maxDt: function() {
      return this.today_ts * 1000
    },


  },
  methods: {
    prevDay() {
      this.dt = this.$moment.unix(this.dt / 1000).add(-1, 'd').unix() * 1000;
    },
    nextDay() {
      this.dt = this.$moment.unix(this.dt / 1000).add(+1, 'd').unix() * 1000;
    },
    disabledDates(date) {
      if (this.$moment(date).unix() * 1000 < this.minDt) return true;
      if (this.$moment(date).unix() * 1000 > this.maxDt) return true;
      return false
    },
    getStations() {
      const self = this;
      let cached_stations = self.$ls.get('uvindex_stations');
      if (cached_stations !== null) {
        self.stations = cached_stations;
        let cached_selected = this.$ls.get('uvindex_selected_station_id');
        if (cached_selected) {
          self.selectedStationId = cached_selected;
        } else {
          self.selectedStationId = this.defaultStationId;
        }

        this.$nextTick(() => {
          self.isStationsLoaded = true;
        });

        //self.getDailyData();
      } else {
        this.isLoading = true;
        Axios.get(SHMUconf.API_BASE_URL + 'uvindex/getstations', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.stations = response.data;
                let cached_selected = this.$ls.get('uvindex_selected_station_id');
                if (cached_selected) {
                  self.selectedStationId = cached_selected;
                } else {
                  self.selectedStationId = this.defaultStationId;
                }
                self.isStationsLoaded = true;
                self.$ls.set('uvindex_stations', self.stations, 24 * 60 * 60 * 1000); // 1 den
                //self.getDailyData();
              } else {
                this.isError = true;
                if (response.data.error[0].text) {
                  this.errorMsg = response.data.error[0].text;
                } else {
                  this.errorMsg = 'Nepodarilo sa načítať zoznam staníc pre UV Index!';
                }
              }
              this.isLoading = false;

            }).catch((error) => {
          this.isError = true;
          this.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
          this.isLoading = false;
        });

      }
    },
    getDailyData() {
      const self = this;

      if (this.selectedStationId === null) {
        this.selectedStationId = this.defaultStationId;
      }
      this.isLoading = true;
      Axios.get(SHMUconf.API_BASE_URL + 'uvindex/getdailydata?station=' + this.selectedStationId + '&dt=' + (this.dt / 1000), {
        crossDomain: true,
        cache: false,
      }).then((response) => {
        if (!response.data.error) {
          self.dailyData = response.data;
          self.dailyDataLoaded = true;
          this.isError = false;
          this.errorMsg = null;
          this.generateChart();

        } else {
          this.isError = true;
          if (response.data.error[0].text) {
            this.errorMsg = response.data.error[0].text;
          } else {
            this.errorMsg = 'Nastala chyba pri načítavaní údajov!';
          }
        }
        this.isLoading = false;
      }).catch((error) => {
        this.isError = true;
        this.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        this.isLoading = false;
      });

    },
    generateChart() {

      let uvdata = [];

      // priprav data pre chart
      if (this.dailyData.length > 0) {
        this.dailyData.forEach((item) => {
          if (item.value !== null) item.value = parseFloat(item.value);
          uvdata.push([item.dt_ts * 1000, item.value]);
        });
      }

      let m1 = this.chartOptions.series.find(item => (item.id) === 'uvDaily');
      m1.data = uvdata;

      this.chartOptions.title.text = 'Priebeh UV Indexu počas dňa ' + this.$moment(this.dt).format('DD.MM.YYYY');



    }
  }
}
</script>

<style lang="scss">
.mx-table-date th {
  border: 0px !important;
}
.mx-datepicker-main {
  color: #000;
}

.mx-calendar-content .cell.active {
  background-color: #1b365d;
}

.mx-table-date .today {
  color: #cd2026 !important;
  background-color: transparent !important;

}

.mx-table-date .today {

&.active {
  color: #fff !important;
  background-color: #cd2026 !important;
}

}

.mx-calendar-content .cell:hover {
  color: #fff;
  background-color: #205493;
}

.mx-datepicker {
  float: left;
}

.mx-datepicker,
.mx-input { width: 120px !important;
  padding: unset;
  margin: unset;
  line-height: 1.3;
  height: unset !important;
  box-shadow: unset!important;
}
.mx-btn {
  color: #000;
  &:hover {
    color: #cd2026;
  }
}



</style>
